/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  CircularProgress as MuiCircularProgress,
  withStyles,
} from '@material-ui/core';
import useSWR from 'swr';
import { dataFetcher, endpoints, baseUrl } from 'Api';
import { Page as PageLoggedIn } from 'Components/page';
import { AppContext, AuthContext } from 'Context';
import { Pathname } from 'Routes';
import useMyAxios from 'hooks/useMyAxios';
import { getUserDetailsFromCode } from 'Api/apiFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { clearAllDummys } from 'store/store';
import axios from 'axios';
import { Page } from '../components/page';
import styles from './index.module.css';
import { UploadModal } from './updateVideo';
import Plan from './plan';
import AffliatePlan from './AffliatePlan';

const CircularProgress = withStyles({
  circle: {
    color: '#fff !important',
  },
})(MuiCircularProgress);

export const PlanForAffliate = ({ userIsSignedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [planName, setPlanName] = useState();
  const { type, id } = useParams();
  const [contentId, setContentId] = useState(id);
  const [contentType, setContentType] = useState(type);
  const {
    setAppSnackbar,
    getSubscription,
    userDetails,
    currentSelectedPlan,
    setCurrentSelectedPlan,
    subscriptionDetails,
    setUserDetails,
    langText,
    referralStatus,
    allPlans,
    setAllPlans,
    daysOfMonths,
    setFirstTimeOnlyChecked,
    setStripeUiSelector,
    setScreatId,
    switchingFunction,
    setmessaged,
    apiCALL,
    managerPrivatePlanAccess,
    userAccessedData,
    mangerToken,
  } = useContext(AppContext);

  const { gettingSubscription, setToken: setUserToken, getToken } = useContext(AuthContext);
  const uploadPercentages = useSelector((state) => state.upload);
  const tokens = getToken();
  useEffect(() => {
    setStripeUiSelector();
    setScreatId('');
    setFirstTimeOnlyChecked(false);
    localStorage.removeItem('firstTimeOnlychecked');
    getSubscription();
  }, []);
  const [uploadModalIsVisible, setUploadModalVisibility] = useState(false);
  const hideUploadModal = () => {
    setUploadModalVisibility(false);
  };
  const [plans, setPlans] = useState([]);
  const planText = langText?.settings?.billPayment?.planList;
  const [paymentToken, setToken] = useState();
  const [priceId, setPriceId] = useState();
  const [email, setEmail] = useState(userDetails?.email);
  const [trial_period_days, setTrial_period_days] = useState('0');
  const [myPlan, setMyPlan] = useState(subscriptionDetails?.current_plan);
  const [freePlanId, setFreePlanId] = useState(undefined);
  const emailCode = new URLSearchParams(location?.search)?.get('email');
  const [privatePlanAccess, setPrivatePlanAccess] = useState(null);
  console.log('manager plan', managerPrivatePlanAccess, 'userAccessedData', userAccessedData);
  console.log('allPlans', allPlans);

  useEffect(() => {
    setMyPlan(subscriptionDetails?.current_plan);
  }, [subscriptionDetails]);

  // Fetch affiliate details to get affiliate code
  useEffect(() => {
    const fetchAffiliateDetails = async () => {
      try {
        const myToken = await getToken();
        const apiUrl = `${baseUrl}/affiliateDetails`;
        const requestBody = {
          token: myToken,
        };
        const response = await axios.post(apiUrl, requestBody);
        if (response.data?.data?.[0]?.private_plan_access) {
          setPrivatePlanAccess(response.data.data[0].private_plan_access);
        }
      } catch (error) {
        // Error fetching affiliate details
      }
    };

    if (tokens) {
      fetchAffiliateDetails();
    }
  }, [tokens, getToken]);

  const {
    response: userDetFrmCode,
    error: userDetFrmCodeErr,
    loading: userDetFrmCodeLoading,
    refetch: refetchuserDetFrmCode,
  } = useMyAxios(
    getUserDetailsFromCode,
    { code: emailCode },
    null,
    emailCode,
    emailCode ? [emailCode] : []
  );

  useEffect(() => {
    if (!userDetFrmCodeLoading && userDetFrmCode && userDetFrmCode?.data) {
      setUserDetails({ ...userDetFrmCode?.data });
      setUserToken(userDetFrmCode?.data?.token);
      window.location.replace(Pathname.plans);
    }
  }, [userDetFrmCode, userDetFrmCodeLoading]);

  const { mutate: getPlans } = useSWR([endpoints.getAllActivePlans], {
    fetcher: (url) => dataFetcher(url, { for_affiliate: true }),
    onSuccess: ({ success, subscriptions, data }) => {
      if (success) {
        if (
          referralStatus
          && parseInt(referralStatus, 10) === 1
          && parseInt(subscriptionDetails?.is_skip, 10) !== 1
          && !subscriptionDetails?.paymentMethods?.length
        ) {
          setAllPlans([...data, subscriptionDetails?.subscription]);
          setFreePlanId(subscriptionDetails?.subscription?.id);
        } else {
          setAllPlans(data);
          setFreePlanId(undefined);
        }
      } else {
        setPlans([]);
      }
    },
    onError: () => {
      setPlans([]);
    },
  });

  // Fetch plans with manager token when manager is accessing
  const fetchPlansWithManagerToken = async () => {
    try {
      const response = await axios.post(`${baseUrl}/${endpoints.getAllActivePlans}`, {
        for_affiliate: true,
        token: mangerToken,
      });
      if (response?.data?.success) {
        setAllPlans(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching plans with manager token:', error);
    }
  };

  useEffect(() => {
    if (subscriptionDetails?.subscription) {
      if (userAccessedData && mangerToken) {
        fetchPlansWithManagerToken();
      } else {
        getPlans();
      }
    }
  }, [referralStatus, subscriptionDetails, userAccessedData, mangerToken]);
  const [isSwitchPlan, setIsSwitchPlan] = useState('1');

  const clearAllDummy = () => {
    dispatch(clearAllDummys());
  };

  const managerTokenFunction = async (obj) => {
    const uploadingOrNot = Object.values(uploadPercentages).some(
      (value) => typeof value === 'number' || value === 'Starting Upload'
    );
    if (!uploadingOrNot) {
      clearAllDummy();
      const result = await switchingFunction(obj);
      if (result?.success) {
        navigate('/dashboard');
      }
    } else {
      setmessaged('You are uploading, so not able to access');
    }
  };

  return (
    <>
      <button
        type="button"
        className={styles.backButton}
        onClick={() => navigate(-1)}
      >
        BACK
      </button>
      <div className={styles.planContainer}>
        <div className={styles.message}>Start Streaming Your Memories!</div>
        <div className={styles.plans}>
          {allPlans
            && allPlans?.length > 0
            && allPlans
              ?.filter((obj, i) => {
                // Hide special plans (is_public === '0') unless user/manager has private plan access
                if (obj?.is_public === '0') {
                  if (userAccessedData) {
                    // Manager accessing - check managerPrivatePlanAccess
                    if (!managerPrivatePlanAccess) {
                      return false;
                    }
                  } else if (privatePlanAccess !== '1' && privatePlanAccess !== 1) {
                    // User's own account - check privatePlanAccess
                    return false;
                  }
                }
                return obj?.hide !== isSwitchPlan;
              })
              ?.map((plan, index) => (
                <AffliatePlan
                  managerTokenFunction={managerTokenFunction}
                  product_name={plan?.product_name}
                  AffliateSpecial={plan?.is_public === '0'}
                  sub_title={plan?.sub_title}
                  amount={`${plan?.amount}`}
                  setIsSwitchPlan={setIsSwitchPlan}
                  isSwitchPlan={isSwitchPlan}
                  needToggle={allPlans?.some(
                    (plan) => plan?.interval_in_days === daysOfMonths
                  )}
                  hideToggle={plan?.hide}
                  plan={plan}
                  description={plan?.description}
                  price_description={plan?.price_description}
                  viewers={
                    plan?.is_unlimited === '1'
                      ? planText?.unlimited || 'unlimited'
                      : plan?.max_view_request
                  }
                  priceDetails={planText?.userMonth || 'user / month'}
                  storage={plan?.max_storage_text}
                  price_id={plan?.price_id}
                  setToken={setToken}
                  setPriceId={setPriceId}
                  setEmail={setEmail}
                  setTrial_period_days={setTrial_period_days}
                  setPlanName={setPlanName}
                  userIsSignedIn={false}
                  currentSelectedPlan={currentSelectedPlan}
                  benefit={`Add ${plan?.max_add_on_allowed} GB of storage for 
            $${(plan?.addon_rate / 100).toFixed(2)}/month`}
                  setCurrentSelectedPlan={setCurrentSelectedPlan}
                  hasTrial={plan?.has_trial}
                  totalTrialDays={plan?.total_trial_days}
                  planId={plan?.id}
                  contentType={contentType}
                  contentId={contentId}
                  freePlanId={freePlanId}
                  color={index % 2 === 0 ? 'white' : 'blue'}
                />
              ))}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
            paddingBottom: '20px',
          }}
        >
          <button
            type="button"
            onClick={() => managerTokenFunction(apiCALL?.data?.userDetails[0])}
            // onClick={() => navigate(Pathname.getSettingsPath('/manage-users'))}
            style={{
              cursor: 'pointer',
              color: '#ffffff',
              margin: 0,
              background: '#0075ff',
              border: '2px solid #0075ff',
              borderRadius: '10px',
              padding: '8px 32px',
              fontSize: '16px',
              fontWeight: '600',
              fontFamily: 'Montserrat, sans-serif',
              textDecoration: 'none',
              transition: 'all 0.3s ease-in-out',
              boxShadow: '0 4px 12px rgba(90, 165, 239, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#0075ff';
              e.target.style.borderColor = '#0075ff';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(90, 165, 239, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#0075ff';
              e.target.style.borderColor = '#0075ff';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(90, 165, 239, 0.3)';
            }}
          >
            Continue with Free Plan
          </button>
        </div>
      </div>
    </>
  );
};
